import React from 'react';
import { CardMedia, Container, Stack, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDevice } from '../../hooks/useResponsive';
import GradientCTAButton from './InspectionButton';

const ScanningCode = () => {
  const { isMobile } = useDevice();

  return (
    <>
      <Container sx={{ pt: 3, pb: 6, px: isMobile ? 2 : 0.8, backgroundColor: 'white' }}>
        <GradientCTAButton text="Get Warranty Assured Inspection" />

        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/transparent.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px', mt: 8 }}
        />
        <Stack pt={3} pb={3} pr={7} px={1.5}>
          <Typography color="#000000" fontSize={24} fontWeight={800} mb={1} lineHeight={1.2}>
            Transparent Reports, <br />
            Just a Scan Away{' '}
          </Typography>
          <Typography fontSize="11px" color="#000000" fontWeight="400">
            Every FOCUS Certified Inspection report is securely stored online.
            <br /> Anyone can verify it by simply scanning the QR code on the report.
          </Typography>
          <Stack gap={1} mt={2}>
            <Typography color="#000000" fontSize="11px">
              📱 QR-enabled reports for instant access
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🔒 Tamper-proof and securely stored
            </Typography>

            <Stack direction="row" alignItems="center" spacing={0.3}>
              <SearchIcon sx={{ fontSize: 16 }} />
              <Typography color="#000000" fontSize="11px">
                Build trust when buying or selling a car
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        <GradientCTAButton text="Book Your Inspection Now" />
      </Container>
    </>
  );
};

export default ScanningCode;
